// UserAvatar.tsx — Co Marca — Avatar de usuario
import React, { useState } from 'react';

interface UserAvatarProps {
    firstName?: string;
    lastName?: string;
    fotoUrl?: string | null;
    size?: 'sm' | 'md' | 'lg';
}

const colors = {
    primary:        '#c1348b',
    primaryDark:    '#8f1f64',
    secondary:      '#61257b',
    secondaryLight: '#8b3fa8',
    accentDark:     '#ea8406',
};

// Asigna un color de gradiente basado en las iniciales
const avatarGradients = [
    `linear-gradient(135deg,${colors.primaryDark},${colors.primary})`,
    `linear-gradient(135deg,#004d7a,${colors.secondary})`,
    `linear-gradient(135deg,#004a3a,${colors.secondaryLight})`,
    `linear-gradient(135deg,#7a4800,${colors.accentDark})`,
    `linear-gradient(135deg,#3b0764,#5b21b6)`,
    `linear-gradient(135deg,${colors.primaryDark},#6b0032)`,
];

function getGradient(firstName?: string, lastName?: string) {
    const name = `${firstName||''}${lastName||''}`;
    const idx  = name.split('').reduce((a,c)=>a+c.charCodeAt(0),0) % avatarGradients.length;
    return avatarGradients[idx];
}

const sizePx = { sm: 32, md: 40, lg: 48 };
const fontPx = { sm: '.65rem', md: '.75rem', lg: '.88rem' };

const UserAvatar: React.FC<UserAvatarProps> = ({ firstName, lastName, fotoUrl, size = 'md' }) => {
    const [imgError, setImgError] = useState(false);
    const initials = firstName && lastName
        ? `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`
        : 'NA';
    const dim      = sizePx[size];
    const grad     = getGradient(firstName, lastName);
    const showPhoto = fotoUrl && !imgError;

    return (
        <div style={{ width:`${dim}px`, height:`${dim}px`, borderRadius:'50%', flexShrink:0, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:showPhoto?'transparent':grad, boxShadow:'0 2px 8px rgba(0,0,0,.1)' }}>
            {showPhoto ? (
                <img src={fotoUrl!} alt={`${firstName} ${lastName}`}
                    style={{ width:'100%', height:'100%', objectFit:'cover' }}
                    onError={()=>setImgError(true)}/>
            ) : (
                <span style={{ fontSize:fontPx[size], fontWeight:'800', color:'#fff', fontFamily:"'DM Sans',sans-serif", letterSpacing:'.02em' }}>
                    {initials}
                </span>
            )}
        </div>
    );
};

export default UserAvatar;